/**
 * Table enlarging
 */
function tableEnlarge() {
	const enlargeTableButtons = document.querySelectorAll('button[data-action="enlarge-table"]');
	enlargeTableButtons.forEach((enlargeTableTrigger) => {
		const outerTableContainer = enlargeTableTrigger.closest('.table-container');
		const dialog = outerTableContainer.querySelector('dialog');
		const dialogTableContainer = dialog.querySelector('.table-container');
		const closeBtn = dialog.querySelector('button[data-action="close-popup"]');
		closeBtn.addEventListener('click', () => dialog.close());

		enlargeTableTrigger.addEventListener('click', () => {
			// if (!dialogTableContainer.hasAttribute('data-simplebar')) {
			// 	new SimpleBar(dialogTableContainer);
			// }
			dialog.showModal();
		});
	});
}
